export default "__VITE_ASSET__$F15F_XD__"